import React from 'react';
import { ServerIcon, ActivityIcon, AlertCircleIcon, WrenchIcon, RefreshCwIcon, ClockIcon, HardDriveIcon, CpuIcon, MemoryStickIcon, NetworkIcon, InfoIcon, ArrowUpCircleIcon, ArrowDownCircleIcon } from 'lucide-react';
export const ServerStatus: React.FC = () => {
  return <div className="space-y-4" data-id="element-2875">
      <div className="flex items-center justify-between mb-4" data-id="element-2876">
        <h1 className="text-2xl font-bold text-secondary flex items-center" data-id="element-2877">
          <ServerIcon size={24} className="mr-2" data-id="element-2878" />
          Server Status & Monitoring
        </h1>
        <div className="flex space-x-2" data-id="element-2879">
          <button className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90" data-id="element-2880">
            Log Sistem
          </button>
          <button className="bg-primary text-secondary px-4 py-2 rounded-md hover:bg-opacity-90 font-medium" data-id="element-2881">
            + Tambah Node
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-id="element-2882">
        <div className="lg:col-span-2" data-id="element-2883">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-2884">
            <div className="p-3 border-b border-gray-200 bg-neutral-light flex justify-between items-center" data-id="element-2885">
              <h2 className="font-bold text-secondary flex items-center" data-id="element-2886">
                <ActivityIcon size={18} className="mr-2 text-primary" data-id="element-2887" />
                Live System Dashboard
              </h2>
              <div className="flex items-center" data-id="element-2888">
                <div className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full flex items-center mr-2" data-id="element-2889">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-1 animate-pulse" data-id="element-2890"></span>
                  Pembaruan Realtime
                </div>
                <button className="p-1 rounded-full hover:bg-gray-200 text-gray-600" title="Refresh data" data-id="element-2891">
                  <RefreshCwIcon size={16} data-id="element-2892" />
                </button>
              </div>
            </div>
            <div className="p-4" data-id="element-2893">
              {/* System Overview Cards */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" data-id="element-2894">
                <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-2895">
                  <div className="flex justify-between items-start mb-2" data-id="element-2896">
                    <div className="flex items-center" data-id="element-2897">
                      <CpuIcon size={18} className="text-primary mr-2" data-id="element-2898" />
                      <h3 className="text-sm font-medium text-secondary" data-id="element-2899">
                        CPU
                      </h3>
                    </div>
                    <span className="text-xs px-1.5 py-0.5 bg-green-100 text-green-800 rounded-full" data-id="element-2900">
                      Normal
                    </span>
                  </div>
                  <div className="flex items-end justify-between mb-2" data-id="element-2901">
                    <div className="text-2xl font-bold text-secondary" data-id="element-2902">45%</div>
                    <div className="text-xs text-gray-500 flex items-center" data-id="element-2903">
                      <ArrowDownCircleIcon size={12} className="text-green-500 mr-1" data-id="element-2904" />
                      -5%
                    </div>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-2905">
                    <div className="bg-green-500 h-2.5 rounded-full" style={{
                    width: '45%'
                  }} data-id="element-2906"></div>
                  </div>
                  <div className="mt-2 flex justify-between text-xs text-gray-500" data-id="element-2907">
                    <span data-id="element-2908">8 Core</span>
                    <span data-id="element-2909">3.6 GHz</span>
                  </div>
                </div>
                <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-2910">
                  <div className="flex justify-between items-start mb-2" data-id="element-2911">
                    <div className="flex items-center" data-id="element-2912">
                      <MemoryStickIcon size={18} className="text-primary mr-2" data-id="element-2913" />
                      <h3 className="text-sm font-medium text-secondary" data-id="element-2914">
                        RAM
                      </h3>
                    </div>
                    <span className="text-xs px-1.5 py-0.5 bg-yellow-100 text-yellow-800 rounded-full" data-id="element-2915">
                      Tinggi
                    </span>
                  </div>
                  <div className="flex items-end justify-between mb-2" data-id="element-2916">
                    <div className="text-2xl font-bold text-secondary" data-id="element-2917">72%</div>
                    <div className="text-xs text-gray-500 flex items-center" data-id="element-2918">
                      <ArrowUpCircleIcon size={12} className="text-red-500 mr-1" data-id="element-2919" />
                      +8%
                    </div>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-2920">
                    <div className="bg-yellow-500 h-2.5 rounded-full" style={{
                    width: '72%'
                  }} data-id="element-2921"></div>
                  </div>
                  <div className="mt-2 flex justify-between text-xs text-gray-500" data-id="element-2922">
                    <span data-id="element-2923">23 GB / 32 GB</span>
                    <span data-id="element-2924">DDR4</span>
                  </div>
                </div>
                <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-2925">
                  <div className="flex justify-between items-start mb-2" data-id="element-2926">
                    <div className="flex items-center" data-id="element-2927">
                      <HardDriveIcon size={18} className="text-primary mr-2" data-id="element-2928" />
                      <h3 className="text-sm font-medium text-secondary" data-id="element-2929">
                        DISK
                      </h3>
                    </div>
                    <span className="text-xs px-1.5 py-0.5 bg-yellow-100 text-yellow-800 rounded-full" data-id="element-2930">
                      Tinggi
                    </span>
                  </div>
                  <div className="flex items-end justify-between mb-2" data-id="element-2931">
                    <div className="text-2xl font-bold text-secondary" data-id="element-2932">68%</div>
                    <div className="text-xs text-gray-500 flex items-center" data-id="element-2933">
                      <ArrowUpCircleIcon size={12} className="text-red-500 mr-1" data-id="element-2934" />
                      +2%
                    </div>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-2935">
                    <div className="bg-yellow-500 h-2.5 rounded-full" style={{
                    width: '68%'
                  }} data-id="element-2936"></div>
                  </div>
                  <div className="mt-2 flex justify-between text-xs text-gray-500" data-id="element-2937">
                    <span data-id="element-2938">1.36 TB / 2 TB</span>
                    <span data-id="element-2939">SSD</span>
                  </div>
                </div>
                <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-2940">
                  <div className="flex justify-between items-start mb-2" data-id="element-2941">
                    <div className="flex items-center" data-id="element-2942">
                      <NetworkIcon size={18} className="text-primary mr-2" data-id="element-2943" />
                      <h3 className="text-sm font-medium text-secondary" data-id="element-2944">
                        BANDWIDTH
                      </h3>
                    </div>
                    <span className="text-xs px-1.5 py-0.5 bg-green-100 text-green-800 rounded-full" data-id="element-2945">
                      Normal
                    </span>
                  </div>
                  <div className="flex items-end justify-between mb-2" data-id="element-2946">
                    <div className="text-2xl font-bold text-secondary" data-id="element-2947">35%</div>
                    <div className="text-xs text-gray-500 flex items-center" data-id="element-2948">
                      <ArrowDownCircleIcon size={12} className="text-green-500 mr-1" data-id="element-2949" />
                      -3%
                    </div>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-2950">
                    <div className="bg-green-500 h-2.5 rounded-full" style={{
                    width: '35%'
                  }} data-id="element-2951"></div>
                  </div>
                  <div className="mt-2 flex justify-between text-xs text-gray-500" data-id="element-2952">
                    <span data-id="element-2953">350 Mbps / 1 Gbps</span>
                    <span data-id="element-2954">Fiber</span>
                  </div>
                </div>
              </div>
              {/* Server Nodes Table */}
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2955">
                <div className="flex justify-between items-center p-3 border-b border-gray-200 bg-neutral-light" data-id="element-2956">
                  <h3 className="text-sm font-medium text-secondary flex items-center" data-id="element-2957">
                    <ServerIcon size={16} className="mr-1.5 text-primary" data-id="element-2958" />
                    Server Nodes Status
                  </h3>
                  <div className="flex items-center" data-id="element-2959">
                    <span className="flex items-center text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full mr-2" data-id="element-2960">
                      <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-1" data-id="element-2961"></span>
                      3 Online
                    </span>
                    <span className="flex items-center text-xs bg-red-100 text-red-800 px-2 py-0.5 rounded-full" data-id="element-2962">
                      <span className="w-1.5 h-1.5 bg-red-500 rounded-full mr-1" data-id="element-2963"></span>
                      1 Offline
                    </span>
                  </div>
                </div>
                <div className="overflow-x-auto" data-id="element-2964">
                  <table className="w-full" data-id="element-2965">
                    <thead className="bg-gray-50" data-id="element-2966">
                      <tr data-id="element-2967">
                        <th className="px-4 py-3 text-left text-xs font-semibold text-secondary" data-id="element-2968">
                          Node
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-secondary" data-id="element-2969">
                          Lokasi
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-secondary" data-id="element-2970">
                          CPU
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-secondary" data-id="element-2971">
                          RAM
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-secondary" data-id="element-2972">
                          Disk
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-secondary" data-id="element-2973">
                          Uptime
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-secondary" data-id="element-2974">
                          Status
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-secondary" data-id="element-2975">
                          Aksi
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200" data-id="element-2976">
                      <tr className="hover:bg-gray-50 transition-colors" data-id="element-2977">
                        <td className="px-4 py-3 text-xs font-medium text-secondary" data-id="element-2978">
                          <div className="flex items-center" data-id="element-2979">
                            <ServerIcon size={14} className="mr-2 text-primary" data-id="element-2980" />
                            srv-pusat-01
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-2981">
                          Pusat/Setuma
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-2982">
                          <div className="flex items-center" data-id="element-2983">
                            <div className="w-16 bg-gray-200 rounded-full h-1.5 mr-2" data-id="element-2984">
                              <div className="bg-green-500 h-1.5 rounded-full" style={{
                              width: '45%'
                            }} data-id="element-2985"></div>
                            </div>
                            <span data-id="element-2986">45%</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-2987">
                          <div className="flex items-center" data-id="element-2988">
                            <div className="w-16 bg-gray-200 rounded-full h-1.5 mr-2" data-id="element-2989">
                              <div className="bg-yellow-500 h-1.5 rounded-full" style={{
                              width: '72%'
                            }} data-id="element-2990"></div>
                            </div>
                            <span data-id="element-2991">72%</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-2992">
                          <div className="flex items-center" data-id="element-2993">
                            <div className="w-16 bg-gray-200 rounded-full h-1.5 mr-2" data-id="element-2994">
                              <div className="bg-yellow-500 h-1.5 rounded-full" style={{
                              width: '68%'
                            }} data-id="element-2995"></div>
                            </div>
                            <span data-id="element-2996">68%</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-2997">
                          <div className="flex items-center" data-id="element-2998">
                            <ClockIcon size={12} className="mr-1 text-gray-400" data-id="element-2999" />
                            45 hari
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs" data-id="element-3000">
                          <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 flex items-center w-fit" data-id="element-3001">
                            <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-1 animate-pulse" data-id="element-3002"></span>
                            Online
                          </span>
                        </td>
                        <td className="px-4 py-3 text-xs" data-id="element-3003">
                          <button className="px-2 py-1 bg-accent-info text-white rounded hover:bg-opacity-90 transition-colors" data-id="element-3004">
                            Detail
                          </button>
                        </td>
                      </tr>
                      <tr className="hover:bg-gray-50 transition-colors" data-id="element-3005">
                        <td className="px-4 py-3 text-xs font-medium text-secondary" data-id="element-3006">
                          <div className="flex items-center" data-id="element-3007">
                            <ServerIcon size={14} className="mr-2 text-primary" data-id="element-3008" />
                            srv-stin-01
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-3009">
                          STIN
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-3010">
                          <div className="flex items-center" data-id="element-3011">
                            <div className="w-16 bg-gray-200 rounded-full h-1.5 mr-2" data-id="element-3012">
                              <div className="bg-green-500 h-1.5 rounded-full" style={{
                              width: '38%'
                            }} data-id="element-3013"></div>
                            </div>
                            <span data-id="element-3014">38%</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-3015">
                          <div className="flex items-center" data-id="element-3016">
                            <div className="w-16 bg-gray-200 rounded-full h-1.5 mr-2" data-id="element-3017">
                              <div className="bg-green-500 h-1.5 rounded-full" style={{
                              width: '55%'
                            }} data-id="element-3018"></div>
                            </div>
                            <span data-id="element-3019">55%</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-3020">
                          <div className="flex items-center" data-id="element-3021">
                            <div className="w-16 bg-gray-200 rounded-full h-1.5 mr-2" data-id="element-3022">
                              <div className="bg-green-500 h-1.5 rounded-full" style={{
                              width: '42%'
                            }} data-id="element-3023"></div>
                            </div>
                            <span data-id="element-3024">42%</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-3025">
                          <div className="flex items-center" data-id="element-3026">
                            <ClockIcon size={12} className="mr-1 text-gray-400" data-id="element-3027" />
                            32 hari
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs" data-id="element-3028">
                          <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 flex items-center w-fit" data-id="element-3029">
                            <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-1 animate-pulse" data-id="element-3030"></span>
                            Online
                          </span>
                        </td>
                        <td className="px-4 py-3 text-xs" data-id="element-3031">
                          <button className="px-2 py-1 bg-accent-info text-white rounded hover:bg-opacity-90 transition-colors" data-id="element-3032">
                            Detail
                          </button>
                        </td>
                      </tr>
                      <tr className="hover:bg-gray-50 transition-colors bg-yellow-50" data-id="element-3033">
                        <td className="px-4 py-3 text-xs font-medium text-secondary" data-id="element-3034">
                          <div className="flex items-center" data-id="element-3035">
                            <ServerIcon size={14} className="mr-2 text-primary" data-id="element-3036" />
                            srv-binda-jatim-01
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-3037">
                          BINDA Jatim
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-3038">
                          <div className="flex items-center" data-id="element-3039">
                            <div className="w-16 bg-gray-200 rounded-full h-1.5 mr-2" data-id="element-3040">
                              <div className="bg-red-500 h-1.5 rounded-full" style={{
                              width: '92%'
                            }} data-id="element-3041"></div>
                            </div>
                            <span className="font-medium text-red-600" data-id="element-3042">
                              92%
                            </span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-3043">
                          <div className="flex items-center" data-id="element-3044">
                            <div className="w-16 bg-gray-200 rounded-full h-1.5 mr-2" data-id="element-3045">
                              <div className="bg-yellow-500 h-1.5 rounded-full" style={{
                              width: '78%'
                            }} data-id="element-3046"></div>
                            </div>
                            <span data-id="element-3047">78%</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-3048">
                          <div className="flex items-center" data-id="element-3049">
                            <div className="w-16 bg-gray-200 rounded-full h-1.5 mr-2" data-id="element-3050">
                              <div className="bg-yellow-500 h-1.5 rounded-full" style={{
                              width: '65%'
                            }} data-id="element-3051"></div>
                            </div>
                            <span data-id="element-3052">65%</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-3053">
                          <div className="flex items-center" data-id="element-3054">
                            <ClockIcon size={12} className="mr-1 text-gray-400" data-id="element-3055" />
                            15 hari
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs" data-id="element-3056">
                          <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 flex items-center w-fit" data-id="element-3057">
                            <span className="w-1.5 h-1.5 bg-yellow-500 rounded-full mr-1 animate-pulse" data-id="element-3058"></span>
                            Warning
                          </span>
                        </td>
                        <td className="px-4 py-3 text-xs" data-id="element-3059">
                          <button className="px-2 py-1 bg-accent-info text-white rounded hover:bg-opacity-90 transition-colors" data-id="element-3060">
                            Detail
                          </button>
                        </td>
                      </tr>
                      <tr className="hover:bg-gray-50 transition-colors bg-red-50" data-id="element-3061">
                        <td className="px-4 py-3 text-xs font-medium text-secondary" data-id="element-3062">
                          <div className="flex items-center" data-id="element-3063">
                            <ServerIcon size={14} className="mr-2 text-gray-400" data-id="element-3064" />
                            srv-binda-sumbar-01
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700" data-id="element-3065">
                          BINDA Sumbar
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-500" colSpan={4} data-id="element-3066">
                          <div className="flex items-center" data-id="element-3067">
                            <InfoIcon size={14} className="mr-2 text-red-500" data-id="element-3068" />
                            <i data-id="element-3069">
                              Server offline sejak 10:15 WIB (2 jam 45 menit)
                            </i>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs" data-id="element-3070">
                          <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 flex items-center w-fit" data-id="element-3071">
                            <span className="w-1.5 h-1.5 bg-red-500 rounded-full mr-1" data-id="element-3072"></span>
                            Offline
                          </span>
                        </td>
                        <td className="px-4 py-3 text-xs" data-id="element-3073">
                          <button className="px-2 py-1 bg-red-600 text-white rounded hover:bg-opacity-90 transition-colors" data-id="element-3074">
                            Detail
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-4" data-id="element-3075">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-3076">
            <div className="p-3 border-b border-gray-200 bg-neutral-light flex items-center justify-between" data-id="element-3077">
              <h2 className="font-bold text-secondary flex items-center" data-id="element-3078">
                <ActivityIcon size={18} className="mr-2" data-id="element-3079" />
                Service Map
              </h2>
              <span className="text-xs bg-accent-info text-white px-2 py-1 rounded" data-id="element-3080">
                Live Status
              </span>
            </div>
            <div className="p-4" data-id="element-3081">
              <div className="bg-neutral-light rounded-lg p-4 mb-4" data-id="element-3082">
                <div className="flex flex-col items-center" data-id="element-3083">
                  {/* Main server */}
                  <div className="w-12 h-12 rounded-full bg-secondary flex items-center justify-center mb-2" data-id="element-3084">
                    <ServerIcon size={24} className="text-white" data-id="element-3085" />
                  </div>
                  <div className="text-xs font-medium text-secondary mb-1" data-id="element-3086">
                    Pusat
                  </div>
                  <div className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-3087">
                    Healthy
                  </div>
                  {/* Connection line */}
                  <div className="h-6 w-px bg-gray-300 my-2" data-id="element-3088"></div>
                  {/* Regional servers */}
                  <div className="grid grid-cols-3 gap-4 w-full" data-id="element-3089">
                    {/* STIN */}
                    <div className="flex flex-col items-center" data-id="element-3090">
                      <div className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center mb-2" data-id="element-3091">
                        <ServerIcon size={20} className="text-white" data-id="element-3092" />
                      </div>
                      <div className="text-xs font-medium text-secondary mb-1" data-id="element-3093">
                        STIN
                      </div>
                      <div className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-3094">
                        Healthy
                      </div>
                    </div>
                    {/* BINDA Jatim */}
                    <div className="flex flex-col items-center" data-id="element-3095">
                      <div className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center mb-2" data-id="element-3096">
                        <ServerIcon size={20} className="text-white" data-id="element-3097" />
                      </div>
                      <div className="text-xs font-medium text-secondary mb-1" data-id="element-3098">
                        BINDA Jatim
                      </div>
                      <div className="text-xs bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full" data-id="element-3099">
                        Warning
                      </div>
                    </div>
                    {/* BINDA Sumbar */}
                    <div className="flex flex-col items-center" data-id="element-3100">
                      <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center mb-2" data-id="element-3101">
                        <ServerIcon size={20} className="text-white" data-id="element-3102" />
                      </div>
                      <div className="text-xs font-medium text-secondary mb-1" data-id="element-3103">
                        BINDA Sumbar
                      </div>
                      <div className="text-xs bg-red-100 text-red-800 px-2 py-0.5 rounded-full" data-id="element-3104">
                        Offline
                      </div>
                    </div>
                  </div>
                  {/* Connection line */}
                  <div className="h-6 w-px bg-gray-300 my-2" data-id="element-3105"></div>
                  {/* Satker servers */}
                  <div className="grid grid-cols-2 gap-4 w-full" data-id="element-3106">
                    {/* Satker A */}
                    <div className="flex flex-col items-center" data-id="element-3107">
                      <div className="w-8 h-8 rounded-full bg-secondary flex items-center justify-center mb-2" data-id="element-3108">
                        <ServerIcon size={16} className="text-white" data-id="element-3109" />
                      </div>
                      <div className="text-xs font-medium text-secondary mb-1" data-id="element-3110">
                        Satker A
                      </div>
                      <div className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-3111">
                        Healthy
                      </div>
                    </div>
                    {/* Satker B */}
                    <div className="flex flex-col items-center" data-id="element-3112">
                      <div className="w-8 h-8 rounded-full bg-secondary flex items-center justify-center mb-2" data-id="element-3113">
                        <ServerIcon size={16} className="text-white" data-id="element-3114" />
                      </div>
                      <div className="text-xs font-medium text-secondary mb-1" data-id="element-3115">
                        Satker B
                      </div>
                      <div className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-3116">
                        Healthy
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Alert - Sumbar */}
              <div className="bg-red-50 border border-red-200 p-3 rounded-lg mb-4" data-id="element-3117">
                <div className="flex items-start" data-id="element-3118">
                  <AlertCircleIcon size={16} className="text-accent-red mt-0.5 mr-2 flex-shrink-0" data-id="element-3119" />
                  <div data-id="element-3120">
                    <h3 className="text-sm font-medium text-secondary" data-id="element-3121">
                      Alert: srv-binda-sumbar-01
                    </h3>
                    <p className="text-xs text-gray-700" data-id="element-3122">
                      Node offline sejak 10:15 WIB (2 jam 45 menit)
                    </p>
                    <p className="text-xs text-gray-700 mt-1" data-id="element-3123">
                      Tindakan: Tim teknis sudah dikirim ke lokasi
                    </p>
                    <div className="mt-2 flex justify-end" data-id="element-3124">
                      <button className="bg-accent-red text-white px-2 py-1 rounded text-xs" data-id="element-3125">
                        Lihat Detail
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* Warning - Jatim */}
              <div className="bg-yellow-50 border border-yellow-200 p-3 rounded-lg" data-id="element-3126">
                <div className="flex items-start" data-id="element-3127">
                  <AlertCircleIcon size={16} className="text-yellow-600 mt-0.5 mr-2 flex-shrink-0" data-id="element-3128" />
                  <div data-id="element-3129">
                    <h3 className="text-sm font-medium text-secondary" data-id="element-3130">
                      Warning: srv-binda-jatim-01
                    </h3>
                    <p className="text-xs text-gray-700" data-id="element-3131">
                      CPU load &gt; 90% selama 15 menit terakhir
                    </p>
                    <p className="text-xs text-gray-700 mt-1" data-id="element-3132">
                      Tindakan: Monitoring berlanjut
                    </p>
                    <div className="mt-2 flex justify-end" data-id="element-3133">
                      <button className="bg-yellow-600 text-white px-2 py-1 rounded text-xs" data-id="element-3134">
                        Lihat Detail
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-3135">
            <div className="p-3 border-b border-gray-200 bg-neutral-light flex items-center justify-between" data-id="element-3136">
              <h2 className="font-bold text-secondary flex items-center" data-id="element-3137">
                <WrenchIcon size={18} className="mr-2" data-id="element-3138" />
                AI Prediction
              </h2>
              <span className="text-xs bg-accent-info text-white px-2 py-1 rounded" data-id="element-3139">
                Powered by AI
              </span>
            </div>
            <div className="p-4" data-id="element-3140">
              <div className="space-y-3" data-id="element-3141">
                <div className="border-l-4 border-yellow-500 pl-3 py-1" data-id="element-3142">
                  <h3 className="text-sm font-medium text-secondary" data-id="element-3143">
                    srv-binda-jatim-01
                  </h3>
                  <p className="text-xs text-gray-700" data-id="element-3144">
                    Prediksi kegagalan disk dalam 45 hari berdasarkan tren I/O
                    dan error log.
                  </p>
                  <div className="mt-1 flex justify-end" data-id="element-3145">
                    <button className="text-xs text-accent-info hover:underline" data-id="element-3146">
                      Jadwalkan Pemeliharaan
                    </button>
                  </div>
                </div>
                <div className="border-l-4 border-accent-info pl-3 py-1" data-id="element-3147">
                  <h3 className="text-sm font-medium text-secondary" data-id="element-3148">
                    srv-pusat-01
                  </h3>
                  <p className="text-xs text-gray-700" data-id="element-3149">
                    Kebutuhan RAM akan mencapai 85% dalam 30 hari dengan tren
                    saat ini.
                  </p>
                  <div className="mt-1 flex justify-end" data-id="element-3150">
                    <button className="text-xs text-accent-info hover:underline" data-id="element-3151">
                      Rencana Upgrade
                    </button>
                  </div>
                </div>
                <div className="border-l-4 border-green-500 pl-3 py-1" data-id="element-3152">
                  <h3 className="text-sm font-medium text-secondary" data-id="element-3153">
                    srv-stin-01
                  </h3>
                  <p className="text-xs text-gray-700" data-id="element-3154">
                    Performa stabil, tidak ada tanda kegagalan dalam 90 hari ke
                    depan.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};